import React from 'react';
import PropTypes from 'prop-types';

// Components
import Icon from 'src/react/components/icon/Icon';

const DefaultEmptyPageHeading = () => (
  <h1 className="mb-2 font-normal text-gray-60 text-6 mb-5">
    <span className="block">No new</span> recommendations.
  </h1>
);

const EmptyPage = (props) => {
  const { children, Header = DefaultEmptyPageHeading, ...otherProps } = props;
  return (
    <div
      data-testid="unlock_recommendations"
      className="w-full flex flex-col sm:w-auto items-center justify-center"
      {...otherProps}
    >
      <Icon name="flame" className="mb-2" />
      <Header />
      <div className="w-full sm:w-auto flex flex-col sm:flex-row justify-center">
        {children}
      </div>
    </div>
  );
};

EmptyPage.propTypes = {
  children: PropTypes.node,
  Header: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func
  ])
};

export default EmptyPage;
